import { ReturnStatusDistribution } from "./return-status-distribution";
import useTranslation from "@babackapp/translations/use-translation";
import { TimeStatCard } from "./time-chart-card";
import { ReturnRequestDailyStatusEvolutionChart } from "./daily-return-chart";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useDashboardFilters } from "../../home/lib/dashboard-filters";
import { useGetReturnRequestAverageTimeSuspense } from "@babackapp/private-api-client/client/use-get-statistics-average-times";
import { useGetDailyStatusEvolutioSuspense } from "@babackapp/private-api-client/client/use-get-statistics-status-repartion";

export default function ReturnOperationsDashboard() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const { toTimestamp, fromTimestamp } = useDashboardFilters();
  const { data: averageTimeData } = useGetReturnRequestAverageTimeSuspense({
    shopId: shop?.id ?? "",
    fromTimestamp: fromTimestamp ?? 0,
    toTimestamp: toTimestamp ?? 0,
  });

  const { data: dailyStatusData } = useGetDailyStatusEvolutioSuspense({
    shopId: shop?.id ?? "",
    fromTimestamp: fromTimestamp ?? 0,
    toTimestamp: toTimestamp ?? 0,
  });

  return (
    <>
      <TimeStatCard
        title={t("operationsDashboard.averagePickupTimeTitle")}
        subtitle={t("operationsDashboard.averagePickupTimeDescription")}
        duration={averageTimeData.averagePickupTime}
        icon="clock"
        color="var(--color-primary)"
      />
      <TimeStatCard
        title={t("operationsDashboard.averageDeliveryTimeTitle")}
        subtitle={t("operationsDashboard.averageDeliveryTimeDescription")}
        duration={averageTimeData.averageDeliveryTime}
        icon="truck"
        color="var(--color-primary)"
      />
      <TimeStatCard
        title={t("operationsDashboard.averageMerchantProcessingTimeTitle")}
        subtitle={t(
          "operationsDashboard.averageMerchantProcessingTimeDescription",
        )}
        duration={averageTimeData.averageMerchantProcessingTime}
        icon="check"
        color="var(--color-primary)"
      />
      <TimeStatCard
        title={t("operationsDashboard.averageLogisticianProcessingTimeTitle")}
        subtitle={t(
          "operationsDashboard.averageLogisticianProcessingTimeDescription",
        )}
        duration={averageTimeData.averageLogisticianProcessingTime}
        icon="package"
        color="var(--color-primary)"
      />
      <ReturnStatusDistribution timeChartData={dailyStatusData} />

      <ReturnRequestDailyStatusEvolutionChart timeChartData={dailyStatusData} />
    </>
  );
}
